module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-114x114-d97b3fc5ff4c9e6b0bde48c3d4e51444.png";